import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { MatSort } from '@angular/material/sort';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import {
  SaleVetModel,
  SaleVetSearchFields,
  SaleVetTableFields,
} from 'src/app/models/sales/sale-vet.model';
import { MatDataSource } from '../../shared-new/util/mat-datasource';

export class SaleVetListDataSource extends MatDataSource<SaleVetModel> {
  
  public constructor(
    data: SaleVetModel[],
    sort: MatSort,
    disableInfiniteScroll: boolean = false,
    scrollLevel: number = 20
  ) {
    super(data, sort, disableInfiniteScroll, scrollLevel);
    this.setFilterPredicate();
  }

  clearFilter(): void {
    this.filter = '';  // Clear the filter value
    this.filteredData = [...this.data];  // Reset the filtered data to the original data
    this._updateChangeSubscription();  // Trigger data refresh
  }

  setFilterPredicate(): void {
    this.filterPredicate = (sale: SaleVetModel, filterValue: string) => {
      return 'firstName,lastName,clinic,email,mobile'.split(',').some((key) => {
        return (
          sale[key as keyof SaleVetModel] &&
          new RegExp(filterValue.trim().toLowerCase(), 'gi').test(
            sale[key as keyof SaleVetModel]
          )
        );
      });
    };
  }
}
